import { IsNotEmpty, IsUUID } from 'class-validator';

export class GetEventTypeOptionsDto {
  @IsUUID()
  @IsNotEmpty()
  companyId: string;
}
